import { useContext } from 'react';

import ThemeContext, {
  type ThemeContextInterface,
} from '@/features/theme-switch/ThemeContext';

const useTheme = () => useContext(ThemeContext) as ThemeContextInterface;

export default useTheme;
